import Partner from '../partner';

/**
 * Create the action
 */

const { thunk, request, success, error } = Partner.index((fetch) => {
    return fetch.get('partner');
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
